
import company from '../api/company'

export const state = {
  company_pagination_data: {},
  company: ''
}

export const getters = {
  company: state => state.company
}

export const mutations = {
  ADD_COMPANY (state, data) {
    state.company = (data)
  },
  SHOW_COMPANY (state, data) {
    state.company = data
  }
}

export const actions = {
  CREATE_COMPANY ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      company.create(data).then(response => {
        commit('ADD_COMPANY', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  SHOW_COMPANY ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      company.show(id).then(response => {
        commit('SHOW_COMPANY', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  EDIT_COMPANY ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      company.update(data, state.company.id).then(response => {
        localStorage.setItem('session_company', JSON.stringify(response.data))
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/company.js